import {
  useWSSnackbar,
  WSButton,
  WSCheckboxToggle,
  WSElement,
  WSElementProps,
  WSInfoBox,
  WSText
} from "@wingspanhq/fe-component-library";
import { Payer } from "@wingspanhq/wingspan-api-sdk";
import React, { useState } from "react";

import { selectorCounterpartyDisplayName } from "../../../../../../shared/selectors/selectorCounterpartyDisplayName";

import { useMutationSubmit } from "./useMutationSubmit";

export type FormW9ConsentProps = {
  onClose: () => void;
  payer: Payer;
} & WSElementProps;

export const ModalShareInformationWithClient: React.FC<FormW9ConsentProps> = ({
  onClose,
  payer,
  ...elementProps
}) => {
  const { openSnackbar } = useWSSnackbar();
  const [shareW9, setShareW9] = useState(false);
  const [submit, submitMeta] = useMutationSubmit({
    onSuccess() {
      openSnackbar({
        type: "success",
        duration: 3000,
        message: `"Consent to share information with client" complete`
      });
      onClose();
    }
  });

  const payerId = payer.id;
  const name = selectorCounterpartyDisplayName(payer) || "the payer";

  return (
    <WSElement {...elementProps}>
      <WSInfoBox>
        <WSText.ParagraphSm weight="medium">
          A client is requesting access to your information
        </WSText.ParagraphSm>
        <WSText.ParagraphSm>
          {`Your client, ${name}, is requesting access to your completed ID verification requirement in order to fulfill the eligibility requirement.`}
        </WSText.ParagraphSm>
      </WSInfoBox>

      <WSCheckboxToggle
        label={`I authorize Wingspan to share the ID verification (including tax information) I've provided with my payer(s) on the Wingspan platform (${name}). I understand this information will be used for compliance and eligibility purposes in accordance with applicable laws and regulations.`}
        my="3XL"
        name="shareW9"
        value={shareW9}
        onChange={value => {
          setShareW9(value);
        }}
      />

      <WSButton
        disabled={!shareW9 || !payerId}
        fullWidth
        loading={submitMeta.isLoading}
        mb="M"
        name="next"
        onClick={() => payerId && submit(payerId)}
      >
        Submit
      </WSButton>
    </WSElement>
  );
};
